import { Inline } from "@bedrock-layout/inline";
import { Split } from "@bedrock-layout/split";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import BreadCrumbs from "Components/molecules/Breadcrumbs";
import FieldGroup from "Components/molecules/FieldGroup";
import Section from "Components/molecules/Section";
import SiteNavigation from "Components/molecules/SiteNavigation";
import { TENANT_FORM_FIELDS } from "Constants/tenantFormFields";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { Box, Button, Divider, Grid, Text } from "theme-ui";
import * as yup from "yup";
import InputFactory from "../../molecules/InputField/InputFactory";
import {saveToken} from "../../../Utils/loginUtil";

const { LOGIN } = TENANT_FORM_FIELDS;

const Login = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const validationSchema = yup.object().shape({
        email: yup
            .string()
            .required("Email is required")
            .email("Please enter a valid email"),
        password: yup.string().required("Password is required"),
    });

    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        mode: "onSubmit",
        resolver: yupResolver(validationSchema),
    });

    const onSubmit = async (formData) => {
        setError('');
        setLoading(true);

        const url = `${process.env.REACT_APP_API_URL}/users/login`;

        try {
            const { data } = await axios.post(url, formData);
            setLoading(false);

            if (data?.result?.token) {
                saveToken(data?.result);
            } else {
                setError('There was a problem with your login request');
            }
        } catch (err) {
            setError(err.response?.data?.message || err.message);
            setLoading(false);
        }
    };

    return (
        <Grid variant="layout" bg="muted">
            <Grid variant="layout.header" bg="background" gap={0}>
                <SiteNavigation />
                <Divider variant="layout.header.divider" color="lightgray" />
                <BreadCrumbs />
                <Box variant="layout.header.form-controls" alignItems="center">
                    <Inline gutter="md" align="start" stretch="start">
                        <Text variant="section">Tenant Management</Text>
                    </Inline>
                </Box>
            </Grid>
            <Box
                as="form"
                onSubmit={handleSubmit(onSubmit)}
                variant="layout.body"
                bg="background"
                py="4"
                px="5"
            >
                <Section>
                    <Text variant="section">{LOGIN.TITLE}</Text>
                    {error && <Text variant="error">{error}</Text>}
                    <Split gutter="md" fraction="2/3">
                        <FieldGroup>
                            {LOGIN.FIELDS.map((field) => (
                                <InputFactory
                                    key={field.name}
                                    register={register}
                                    error={errors[field.name]}
                                    {...field}
                                />
                            ))}
                        </FieldGroup>
                    </Split>
                    <Split gutter="md" fraction="2/3">
                        <Button variant="primary" disabled={loading}>
                            Submit
                        </Button>
                    </Split>
                </Section>
            </Box>
        </Grid>
    );
};

export default Login;
